import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import SuiteFeatureTableHeaderCell from './SuiteFeatureTableHeaderCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StaticTable = styled.table.withConfig({
  displayName: "SuiteFeatureTableHeader__StaticTable",
  componentId: "j1lfd7-0"
})(["margin-bottom:0;"]);
const THead = styled.thead.withConfig({
  displayName: "SuiteFeatureTableHeader__THead",
  componentId: "j1lfd7-1"
})(["height:155px;vertical-align:bottom;& tr th:first-of-type{font-size:1.5rem;font-weight:600;text-align:left;border:none !important;}"]);
const SuiteFeatureTableHeader = ({
  levels,
  isFreeToStarter,
  location
}) => {
  return /*#__PURE__*/_jsx(StaticTable, {
    children: /*#__PURE__*/_jsx(THead, {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          className: "p-bottom-3 p-left-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.productCatalog.tableHeader.features"
          })
        }), levels.map(level => {
          return /*#__PURE__*/_jsx(SuiteFeatureTableHeaderCell, {
            productLevel: level,
            columns: levels.length,
            isFreeToStarter: isFreeToStarter,
            location: location
          }, level);
        })]
      })
    })
  });
};
export default SuiteFeatureTableHeader;